var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.76,
    height: 17.96,
    viewBox: "0 0 13.76 17.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-download",
    transform: "translate(-551.12 -311.77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M14,3V6.36a.84.84,0,0,0,.84.84H18.2",
    transform: "translate(545.68 309.77)",
    fill: "none",
    stroke: "#9f9f9f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M15.08,18.96H6.68A1.729,1.729,0,0,1,5,17.187V4.773A1.729,1.729,0,0,1,6.68,3h5.88l4.2,4.433v9.753A1.729,1.729,0,0,1,15.08,18.96Z",
    transform: "translate(547.12 309.77)",
    fill: "none",
    stroke: "#9f9f9f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M12,16.04V11",
    transform: "translate(546 309.003)",
    fill: "none",
    stroke: "#9f9f9f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M9.5,14.5l2.1,2.1,2.1-2.1",
    transform: "translate(546.4 308.496)",
    fill: "none",
    stroke: "#9f9f9f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.7291741d602cba6623e769660d0648bc.svg";
export { ForwardRef as ReactComponent };